module.exports = __webpack_public_path__ + "assets/img/2.97705a84.png";